import type { SurveyPage } from '../../fetchSurvey/types/survey';

export function findPageIndexForQuestion(pages: SurveyPage[], questionId: string): number {
  return pages.findIndex(page => page.questions.some(q => q.id === questionId));
}

export function findLastPageWithQuestions(pages: SurveyPage[]): number {
  for (let i = pages.length - 1; i >= 0; i -= 1) {
    if (pages[i].questions.length > 0) return i;
  }
  return -1;
}

export function isForwardPageTarget(fromPageIndex: number, targetPageIndex: number): boolean {
  return targetPageIndex >= fromPageIndex;
}
